// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import Loader from "@store/Library/Components/Toolkit/Loader";
import React from "react";
import { connect } from "react-redux";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import CheckoutReviewAndSubmitSplitOrders from "@store/Library/Components/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitSplitOrders";
import { orderV2Props } from "@store/Themes/common/props/orderV2";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

const enum fields {
    orderNotesMaxLength = "orderNotesMaxLength",
    showLineNumber = "showLineNumber",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.orderNotesMaxLength]: number;
        [fields.showLineNumber]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);

    return {
        cartState,
        language: state.context.session.language,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface CheckoutReviewAndSubmitSplitOrdersStyles {
    orderWrapper?: InjectableCss;
}

export const productListStyles: CheckoutReviewAndSubmitSplitOrdersStyles = {
    orderWrapper: orderV2Props.sectionWrapper,
};

const styles = productListStyles;

const CheckoutReviewAndSubmitSplitOrdersByOrder = ({
    cartState,
    fields: { orderNotesMaxLength, showLineNumber },
}: Props) => {
    if (!cartState.value || !cartState.value.cartLines) {
        return (
            <StyledWrapper {...styles.orderWrapper}>
                <Loader />
            </StyledWrapper>
        );
    }

    const cart = cartState.value;

    if (getBooleanProperty(cart.properties.softSubmitFatalError)) {
        return <InfosBox>{siteMessage("CheckoutReview_CantShowCartSafe")}</InfosBox>;
    }

    return (
        <CheckoutReviewAndSubmitSplitOrders
            cart={cart}
            orderNotesMaxLength={orderNotesMaxLength}
            showLineNumber={showLineNumber}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CheckoutReviewAndSubmitSplitOrdersByOrder),
    definition: {
        displayName: "Split Orders",
        allowedContexts: ["CheckoutReviewAndSubmitPage"],
        group: "Checkout - Review & Submit",
        fieldDefinitions: [
            {
                name: fields.orderNotesMaxLength,
                editorTemplate: "IntegerField",
                min: 0,
                max: 2080,
                defaultValue: 2080,
                fieldType: "General",
            },
            {
                name: fields.showLineNumber,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                variant: "toggle",
            },
        ],
    },
};

export default widgetModule;
